import React, { useState, useRef } from 'react';
import * as _ from 'lodash';

// modals
import { Confirmation } from '../modals/common';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';

//utilities
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';

//service
import SessionStorageService from '../../services/utilities/SessionStorageService';
import DirectNoticeUnapprovedWorkSettingsApi from '../../services/DirectNoticeUnapprovedWorkSettingsApi';

//pages
import { useGetReloadExternalServiceCooperationPage } from '../../pages/ExternalServiceCooperation';

export default function DirectNoticeStopModal({ visible, setVisible }) {
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const isSending = useRef(false);
  const reloadAction = useGetReloadExternalServiceCooperationPage();
  const onClose = () => {
    setVisible(false);
    reloadAction();
  };
  const onConfirm = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const fieldId = SessionStorageService.getFieldId();
      const {
        data,
        result,
        status,
      } = await DirectNoticeUnapprovedWorkSettingsApi.destroy(fieldId);
      setVisible(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowErrorModal(true);
        return;
      }
      onClose();
    } catch (error) {
      setIsShowErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };
  return (
    <React.Fragment>
      <Confirmation
        visible={visible}
        rootClassName={'DirectDescriptionModal--NoticeSettingStop'}
        title={messageUtility.getMessage('I-001-577')}
        message={messageUtility.getMessage('I-001-578')}
        confirmButtonText={messageUtility.getMessage('I-000-254')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={onConfirm}
        isNegative={true}
        onCancel={() => {
          setVisible(false);
        }}
        tabFocus={true}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
        closeAction={onClose}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectNoticeStopModal.jsx